<template>
  <el-form-item
    :label="$attrs.label"
    :prop="$attrs.name"
    class="elsa-input"
    ref="search"
  >
    <el-input
      v-bind="$attrs"
      v-model="modelProp"
      @input="addBorder"
      @focus="addBorder"
      @change="removeBorder"
      prefix-icon="el-icon-search"
      :placeholder="$t('common.search')"
    >
      <template #append>
        <i @click="resetSearch" class="el-icon-close" />
        <button @click="searchBy">{{ $t('common.search') }}</button>
      </template>
    </el-input>
  </el-form-item>
</template>

<script>
export default {
  name: "ElsaSearch",
  props: ['value'],
  computed: {
    modelProp: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    }
  },
  methods: {
    addBorder() {
      const searchInput = this.$refs.search.$el
      searchInput.classList.add('on-focus')
    },
    removeBorder() {
      const searchInput = this.$refs.search.$el
      searchInput.classList.remove('on-focus')
    },
    searchBy(event) {
      event.preventDefault()
      this.$emit('search', this.modelProp)
    },
    resetSearch() {
      this.modelProp = ''
      this.$emit('search', '')
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '../../scss/colors';
  .el-input {
    border: 1px solid $light-blue;
    border-radius: 16px;
  }

  ::v-deep .el-input-group__append {
    width: 80px;
    padding: 0 8px;
    align-items: center;
    display: flex;
    justify-content: center;
    background-color: white;
    border: none;
    margin-right: 8px;
  }

  button {
    border: 1.5px solid $purple;
    border-radius: 40px;
    font-family: 'SF Pro Display';
    font-weight: 500;
    font-size: 12px;
    color: $purple;
    padding: 2px 10px;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }

  i {
    margin-right: 10px;
    cursor: pointer;
    font-size: 15px;
    color: $purple;
  }

  .on-focus .el-input {
    border: 2px solid $purple;
  }

  .elsa-input::v-deep .el-input .el-input__inner {
    border: none !important;
    text-indent: 30px;
  }

</style>
